import { render, staticRenderFns } from "./STBShop.vue?vue&type=template&id=6d9b6cbf&scoped=true"
import script from "./STBShop.vue?vue&type=script&lang=js"
export * from "./STBShop.vue?vue&type=script&lang=js"
import style0 from "./STBShop.vue?vue&type=style&index=0&id=6d9b6cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b6cbf",
  null
  
)

export default component.exports